// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // 👈 Yeh naya add kiya Database ke liye
import { getAuth } from "firebase/auth";           // 👈 Yeh naya add kiya Auth ke liye

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqObmMeDHSgvIuBN3fvHsO_-2Ahkxd_2c",
  authDomain: "mrlappy-bff8c.firebaseapp.com",
  projectId: "mrlappy-bff8c",
  storageBucket: "mrlappy-bff8c.firebasestorage.app",
  messagingSenderId: "594933418223",
  appId: "1:594933418223:web:3163e63a3007a714d2b31a",
  measurementId: "G-7CFRZC7P10"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 🚀 Sabsbe Important: Inko initialize karke EXPORT kiya taaki baaki files use kar sakein
export const db = getFirestore(app);
export const auth = getAuth(app);